import { Badge, FlexLayout } from '@deity/falcon-ui';
import type { IValidationResult } from '@deity-io/di-data-flows-editor';
import { Icon } from '@deity-io/portal-ui';
import type { FC } from 'react';
import styles from 'styling/badges.module.css';

const xxs: any = 'xxs';

type ValidationStatusBadgeProps = {
  validation: IValidationResult;
};
export const ValidationStatusBadge: FC<ValidationStatusBadgeProps> = ({ validation }) => {
  const isValid = validation.valid === true;

  return (
    <FlexLayout alignItems="center" width="full">
      <Badge py={xxs} fontWeight="bold" className={isValid ? styles.success : styles.inactive}>
        <FlexLayout alignItems="center" mr="xs" fontSize="xxs">
          <Icon icon="notStarted" sx={{ height: 18, width: 18 }} />
        </FlexLayout>
        {isValid ? 'VALID' : 'INVALID'}
      </Badge>
    </FlexLayout>
  );
};
